import styled from 'styled-components';
import ConfidentialitySvg from '../../../assets/onboardingNew/homepage/confidentiality.svg';

const ConfidentialityNewIcon = styled(ConfidentialitySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.6rem'};
height: ${props => props.height || '3.6rem'};
display: flex;
`;

export default ConfidentialityNewIcon;
